import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
var IconPlay = function IconPlay(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M-1473.586,52a47.7,47.7,0,0,1-18.684-3.772,47.839,47.839,0,0,1-15.257-10.287,47.84,47.84,0,0,1-10.287-15.258A47.7,47.7,0,0,1-1521.586,4a47.7,47.7,0,0,1,3.772-18.684,47.84,47.84,0,0,1,10.287-15.257,47.839,47.839,0,0,1,15.257-10.287A47.7,47.7,0,0,1-1473.586-44a47.7,47.7,0,0,1,18.684,3.772,47.842,47.842,0,0,1,15.257,10.287,47.839,47.839,0,0,1,10.287,15.257A47.7,47.7,0,0,1-1425.587,4a47.7,47.7,0,0,1-3.772,18.684,47.841,47.841,0,0,1-10.287,15.258A47.842,47.842,0,0,1-1454.9,48.228,47.7,47.7,0,0,1-1473.586,52Zm-9.519-64.32V20.32L-1454.351,4l-28.754-16.32Z",
      transform: "translate(1521.586 44)",
      fill: "#e6e6e6"
    })
  }));
};
IconPlay.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "95.999",
  height: "96",
  viewBox: "0 0 95.999 96"
};
import styles from "@/styles/Video.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export default function PlayerSurface(_ref) {
  let {
    active,
    onClick
  } = _ref;
  if (!active) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: styles.surface,
    children: /*#__PURE__*/_jsx("span", {
      className: styles.button,
      onClick: onClick,
      children: /*#__PURE__*/_jsx(IconPlay, {})
    })
  });
}